var app = angular.module('directives.sliderServicesAll', [])

require('./directive.js');

module.exports =  app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderServicesAll/index.js
 ** module id = 230
 ** module chunks = 1
 **/